module.exports = __webpack_public_path__ + "img/plug.0d845255.svg";